import _ from 'lodash'
import {exists} from './general'

export function objectEmpty(obj) {
	return Object.keys(obj).length === 0 || !Object.values(obj).some(c2 => exists(c2))
}

export function objPresent(item) {
	return _.isObject(item) && Object.values(item).some(i => exists(i))
}
